var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdbisLogoIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 55,
    fill: "none",
    viewBox: "0 0 237 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_57_210)",
    d: "M78.523 46.812C69.323 26 63.448 26.926 61.66 29.99 53.685 10 82.185 16.893 97.432 22.84l14.389 26.589c-6.894 8.672-24.098 18.196-33.298-2.616z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_57_210)",
    d: "M32.355 80H0c11.577-20.501 38.093-64.32 43.068-69.408 22.233-22.74 47.916-5.988 60.192 23.032-16.175-15.394-26.347-20.19-42.104-2.604L32.356 80z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_57_210)",
    d: "M75.138 79.926c0-5.738 4.651-10.39 10.389-10.39h26.223c0 5.738-4.651 10.39-10.389 10.39H75.138z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_57_210)",
    d: "M64.755 47.2c-9.054 0-16.394 6.976-16.394 15.583v3.636h20.22c.49 0 .976-.02 1.456-.06H98.84c6.798 0 18.973-7.096 11.83-19.047H84.974v-.113h-20.22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_57_210)",
    d: "M191.025 41.75a4.15 4.15 0 014.151-4.15h3.91v3.85a4.15 4.15 0 01-4.151 4.15h-3.91v-3.85z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#211F54",
    d: "M121.066 49.894h10.825c3.161 0 5.907.337 8.236 1.012 2.33.675 4.257 1.644 5.781 2.907a11.445 11.445 0 013.419 4.575c.756 1.787 1.134 3.8 1.134 6.037 0 2.125-.372 4.094-1.115 5.906-.743 1.8-1.876 3.363-3.4 4.688-1.524 1.312-3.451 2.343-5.781 3.093-2.33.738-5.075 1.107-8.236 1.107l-10.863-.019V49.894zm12.298 24.169c1.789 0 3.357-.225 4.704-.675 1.348-.463 2.469-1.113 3.363-1.95a7.908 7.908 0 002.04-3.038c.453-1.188.68-2.513.68-3.975 0-1.438-.227-2.731-.68-3.881a7.485 7.485 0 00-2.04-2.944c-.894-.813-2.015-1.438-3.363-1.875-1.347-.438-2.915-.656-4.704-.656h-6.309v18.993h6.309zM156.468 49.894h15.774c1.927 0 3.602.206 5.025.619 1.436.4 2.626.956 3.57 1.668.945.713 1.644 1.563 2.097 2.55.466.975.699 2.032.699 3.169 0 1.863-.592 3.494-1.775 4.894 1.36.8 2.374 1.837 3.041 3.112.668 1.275 1.001 2.725 1.001 4.35 0 1.363-.233 2.594-.699 3.694a7.226 7.226 0 01-2.097 2.831c-.932.775-2.115 1.375-3.551 1.8-1.423.413-3.105.619-5.044.619h-18.041V49.894zm18.079 11.25c.516 0 1.02.019 1.511.056.844-.8 1.266-1.713 1.266-2.738 0-1.062-.422-1.88-1.266-2.456-.831-.587-2.053-.881-3.665-.881h-9.936v6.019h12.09zm.113 12.881c1.612 0 2.834-.344 3.665-1.031.844-.688 1.266-1.656 1.266-2.906 0-1.25-.422-2.225-1.266-2.925-.831-.7-2.053-1.05-3.665-1.05h-12.203v7.912h12.203zM191.228 49.894h6.026V79.2h-6.026V49.894zM206.284 70.481c1.07.6 2.153 1.144 3.249 1.632 1.108.475 2.254.88 3.438 1.218 1.184.325 2.424.575 3.722.75 1.309.175 2.701.263 4.174.263 1.776 0 3.288-.113 4.534-.338 1.247-.237 2.261-.556 3.042-.956.793-.412 1.366-.9 1.719-1.462a3.31 3.31 0 00.548-1.838c0-1.063-.447-1.9-1.342-2.513-.894-.624-2.273-.937-4.137-.937-.818 0-1.681.056-2.588.169-.907.1-1.826.212-2.758.337-.919.125-1.832.244-2.739.356-.894.1-1.738.15-2.531.15-1.323 0-2.595-.168-3.816-.506-1.209-.337-2.286-.843-3.231-1.519a7.578 7.578 0 01-2.229-2.53c-.554-1.013-.831-2.194-.831-3.544 0-.8.107-1.594.321-2.382a7.974 7.974 0 011.058-2.25 9.124 9.124 0 011.889-2.006c.768-.625 1.694-1.163 2.777-1.613 1.096-.45 2.355-.8 3.778-1.05 1.436-.262 3.067-.393 4.893-.393 1.322 0 2.651.075 3.986.225a38.32 38.32 0 013.892.6 35.66 35.66 0 013.664.956c1.172.363 2.261.769 3.269 1.219l-2.626 4.8a26.747 26.747 0 00-2.683-.994 29.988 29.988 0 00-3.004-.806 32.588 32.588 0 00-3.249-.525 27.595 27.595 0 00-3.4-.206c-1.65 0-3.01.118-4.081.356-1.058.237-1.901.544-2.531.919-.63.362-1.07.774-1.322 1.237-.24.45-.359.9-.359 1.35 0 .875.396 1.594 1.19 2.156.793.55 2.002.825 3.627.825.655 0 1.404-.044 2.248-.131.856-.1 1.75-.206 2.682-.319.945-.112 1.902-.212 2.872-.3.982-.1 1.933-.15 2.852-.15 1.738 0 3.275.194 4.61.581 1.347.388 2.475.944 3.381 1.67a6.914 6.914 0 012.059 2.606c.466 1.012.699 2.15.699 3.412 0 1.688-.396 3.194-1.19 4.519-.781 1.312-1.901 2.425-3.362 3.337-1.449.9-3.199 1.588-5.252 2.063-2.053.462-4.339.694-6.857.694-1.663 0-3.287-.107-4.874-.32a36.97 36.97 0 01-4.572-.862 37.563 37.563 0 01-4.156-1.368 31.744 31.744 0 01-3.646-1.763l3.193-4.819z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_210",
    x1: 86.05,
    x2: 86.05,
    y1: 16.688,
    y2: 59.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4084FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_210",
    x1: 51.63,
    x2: 51.63,
    y1: 0,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4084FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_210",
    x1: 93.444,
    x2: 93.444,
    y1: 69.537,
    y2: 79.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4084FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_210",
    x1: 80.602,
    x2: 80.602,
    y1: 47.199,
    y2: 66.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4084FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_210",
    x1: 195.055,
    x2: 195.055,
    y1: 37.6,
    y2: 45.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4084FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdbisLogoIndex);
export default __webpack_public_path__ + "static/media/adbis-logo-index.51d27d1d82bfac6e20b6318d9782ad61.svg";
export { ForwardRef as ReactComponent };